module.exports = __webpack_public_path__ + "img/logo_green_balkans.108f9bd1.png";